module.exports = __webpack_public_path__ + "img/76137.10beead5.svg";